export enum IdentitySyncOperationType {
  EmployeeModified = 'EmployeeModified',
  EmployeeEnabled = 'EmployeeEnabled',
  EmployeeDisabled = 'EmployeeDisabled',
  CustomerModified = 'CustomerModified',
  CustomerEnabled = 'CustomerEnabled',
  CustomerDisabled = 'CustomerDisabled',
  OpoUserDataUpdated = 'UpdateUserData.Opo',
}

export type WsIdentitySyncFailedMessageContent = {
  targetUserId: string | null;
  entityId: string | null;
  operationType: IdentitySyncOperationType;
  timestamp: string;
};
